import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import LoaderComponent from '@components/LoaderComponent';
import TimeBasedLoader from '@components/TimeBasedLoader';
import { toastError } from '@components/Toast';

import { TechpackTimer } from '@features/designTool/components/TechpackTimer';

import { fetchPublicTechpack, fetchTechPack } from '@store/actions/TechPackAction';

import ApiClient from '@lib/apiClient';

import { parseHtml } from '@utils/Util';

import { useTechpackDesignUpdateStore } from '@/store/reducers';
// import { useGetDownloadCheckListQuery } from '@/features/design/api/designDetailsApi';
// import { setShowCheckList } from '@/features/design/redux/designUpdateSlice';

const Techpack = ({ setLoader, isDesignSaved, isGlobal }) => {
	const techPackPages = useSelector((store) => store.techPackStore);
	const dispatch = useDispatch();
	const { id } = useParams();
	const [checkedItems, setCheckedItems] = useState([]);
	const [downloadLoading, setDownloadLoading] = useState(false);
	const [localLoading, setLocalLoading] = useState(true);
	const [hasError, setHasError] = useState(null);
	const [remainingTime, setRemainingTime] = useState(null);
	// const { data: dropdownList } = useGetDownloadCheckListQuery({ id });
	const { showChecklist } = useTechpackDesignUpdateStore();

	// useEffect(() => {
	// 	if (dropdownList) {
	// 		dispatch(setShowCheckList(!dropdownList?.isChecklistHidden));
	// 	}
	// }, [dropdownList?.isChecklistHidden]);

	const updateRemainingTime = (newValue) => {
		setRemainingTime(newValue);
	};
	const updateHasError = (err) => {
		setHasError(err);
	};

	useEffect(() => {
		if (!isGlobal) {
			if (isDesignSaved === true) {
				dispatch(fetchTechPack(id));
				setLoader(false);
			} else {
				setLoader(true);
			}
		} else {
			dispatch(fetchPublicTechpack(id, updateRemainingTime, updateHasError));
			setLocalLoading(false);
		}
	}, [id, isDesignSaved]);

	useEffect(() => {
		initializeCheckedItems(techPackPages);
	}, [techPackPages]);

	const initializeCheckedItems = (techPackPages) => {
		let pageNumbers = techPackPages.map((page, index) => index);
		setCheckedItems(pageNumbers);
	};

	const onCheck = (index) => {
		if (isChecked(index)) {
			let filteredItems = checkedItems.filter((element) => element !== index);
			setCheckedItems(filteredItems);
		} else {
			let items = [...checkedItems];
			items.push(index);
			setCheckedItems(items);
		}
	};

	const onCheckAll = () => {
		if (isAllChecked()) setCheckedItems([]);
		else initializeCheckedItems(techPackPages);
	};

	const isChecked = (index) => {
		return checkedItems.includes(index);
	};

	const isAllChecked = () => {
		return checkedItems.length === techPackPages.length;
	};

	const publicTechpackDownload = async () => {
		setDownloadLoading(true);
		let currentTime = moment(new Date()).format('DD MMM [AT] hh:mm A');
		await ApiClient.GET('downloadPublicTechPack', `${id}?currentTime=${currentTime}`)
			.then((response) => {
				if (response.data) {
					setDownloadLoading(false);
					window.open(response?.data, '_parent');
				}
			})
			.catch((error) => {
				setDownloadLoading(false);
				toastError(error?.data?.message || 'Something went wrong');
			});
	};

	const download = async () => {
		setDownloadLoading(true);
		let currentTime = moment(new Date()).format('DD MMM [AT] hh:mm A');
		await ApiClient.POST(
			'downloadTechPack',
			{
				pageNumbers: checkedItems,
				currentTime: currentTime,
				showAllArtBoardPages: true,
				downloadAllPages: true,
				hideChecklist: !showChecklist
			},
			id
		)
			.then((response) => {
				if (response.data) {
					setDownloadLoading(false);
					window.open(response.data, '_parent');
				}
			})
			.catch((error) => {
				setDownloadLoading(false);
				toastError(error.response.data.message);
			});
	};

	return (
		<div className="dashboard-container techpack-dashboard-container">
			{isGlobal ? (
				<LoaderComponent loading={localLoading}>
					<div className="global-techpack-header">
						<img
							src={`${process.env.PUBLIC_URL}/icons/nitex-logo.svg`}
							alt="logo"
							width={85}
							height={24}
						/>
					</div>
					{techPackPages.length > 0 && (
						<div className="download-info d-flex justify-content-between align-items-center">
							<div>
								<TechpackTimer remainingTime={remainingTime} />
							</div>
							<div>
								<button className="button outline size36">
									<img
										src={`${process.env.PUBLIC_URL}/icons/download-dark-20.svg`}
										alt="download"
									/>
									<span className="ml-1" onClick={() => publicTechpackDownload()}>
										Download
									</span>
								</button>
							</div>
						</div>
					)}
					{hasError && (
						<div className="alert alert-secondary text-center">
							<p>Time&#39;s up! The link is currently invalid.</p>
						</div>
					)}
				</LoaderComponent>
			) : (
				<div className="all-template-select">
					<div className="custom-chekbox">
						<div className="form-group m-0">
							<input
								type="checkbox"
								id="all_template"
								name="all"
								checked={isAllChecked()}
								onChange={() => onCheckAll()}
							/>
							<label htmlFor="all_template">
								<span>ALL</span>
							</label>
						</div>
					</div>
					<button className="button text size32">
						<img src={`${process.env.PUBLIC_URL}/icons/download-gray-dark-02.svg`} alt="" />
						<span className="gray_dark_02" onClick={() => download()}>
							Download
						</span>
					</button>
				</div>
			)}

			<div className="techpack-full-container">
				{techPackPages.map((page, index) => {
					return (
						<div className="single-page-template" key={`techpack_images_${index}`}>
							{!isGlobal && (
								<div className="custom-chekbox">
									<div className="form-group m-0">
										<input
											type="checkbox"
											id={index}
											name={index}
											value={index}
											checked={isChecked(index)}
											onClick={() => onCheck(index)}
										/>
										<label htmlFor={index} />
									</div>
								</div>
							)}
							<div dangerouslySetInnerHTML={{ __html: parseHtml(page) }}></div>
						</div>
					);
				})}
			</div>
			{downloadLoading && <TimeBasedLoader startLoader={downloadLoading} />}
		</div>
	);
};

export default Techpack;
